var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 73.518,
    viewBox: "0 0 72 73.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 72,
    height: 73.518,
    fill: "#1e61ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M66.039,72.661h0c-11.1,3.7-19.84-5.736-20.476-6.446a27.507,27.507,0,0,1-3.51-4.412c-2.05-3.015-3.08-4.527-7.294-3.123a31.874,31.874,0,0,0-5.221,2.431,23.935,23.935,0,0,1-4.045,1.817C14.21,66.688,8.061,56.891,1.555,46.518-.275,43.6-.49,40,.914,35.821,5.327,22.685,24.748,6.758,39.164,1.293c.26-.1.517-.19.776-.276C51.4-2.8,63.235,4.712,69,14.11c3.655,5.96,4,11.562.9,14.616a113.085,113.085,0,0,1-9.981,8.962c-2.614,2.09-4.19,3.352-9.124,9.495a6.058,6.058,0,0,0-1.042,5.736c1.861,6.556,11.521,13.636,19.4,16.435a1.014,1.014,0,0,1,.161,1.838,18.477,18.477,0,0,1-3.276,1.469m-31.923-15.9c5.671-1.89,7.5.8,9.613,3.907a25.762,25.762,0,0,0,3.277,4.129c.016.016.034.034.049.051.083.092,8.342,9.224,18.343,5.893h0q.447-.148.895-.33c-8-3.434-16.6-10.273-18.493-16.936a8.076,8.076,0,0,1,1.411-7.558c5.074-6.318,6.716-7.631,9.438-9.808a110.288,110.288,0,0,0,9.824-8.824c2.392-2.357,1.93-7-1.206-12.11C61.939,6.476,50.45-.814,39.883,3.189,26.175,8.386,7.005,24.054,2.836,36.466c-1.2,3.578-1.053,6.6.436,8.974,7.348,11.71,12.466,18.6,21.58,15.565a21.868,21.868,0,0,0,3.7-1.665,33.9,33.9,0,0,1,5.566-2.583",
    transform: "translate(0 0)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M8.356,39.824a.615.615,0,0,1-.671-.221.7.7,0,0,1,.041-.942L42.644,6.508a.6.6,0,0,1,.876.1.7.7,0,0,1-.042.942L8.56,39.7a.548.548,0,0,1-.2.122",
    transform: "translate(2.661 2.249)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M13.029,44.3a.619.619,0,0,1-.68-.23.7.7,0,0,1,.057-.939L44.672,14.638a.6.6,0,0,1,.873.118.7.7,0,0,1-.057.939L13.222,44.188a.562.562,0,0,1-.194.112",
    transform: "translate(4.314 5.128)",
    fill: "#1e61ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M18.973,47.093a.618.618,0,0,1-.686-.238.7.7,0,0,1,.07-.938L46.02,22.271a.6.6,0,0,1,.874.13.7.7,0,0,1-.072.939L19.159,46.986a.526.526,0,0,1-.185.107",
    transform: "translate(6.416 7.83)",
    fill: "#1e61ad"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.9c4bd30fe96a30825cf01e685b86a840.svg";
export { ForwardRef as ReactComponent };